//***************************** ACTUALITY *******************************
// GET
export const GET_ACTUALITY = "GET_ACTUALITY"
export const GET_ACTUALITY_SUCCESS = "GET_ACTUALITY_SUCCESS"
export const GET_ACTUALITY_BY_ID = "GET_ACTUALITY_BY_ID"
export const GET_ACTUALITY_BY_ID_SUCCESS = "GET_ACTUALITY_BY_ID_SUCCESS"
export const POST_ACTUALITY = "POST_ACTUALITY"
export const POST_ACTUALITY_SUCCESS = "POST_ACTUALITY_SUCCESS"
export const POST_FILE_ACTUALITY = "POST_FILE_ACTUALITY"
export const POST_FILE_ACTUALITY_SUCCESS = "POST_FILE_ACTUALITY_SUCCESS"
export const PATCH_ACTUALITY = "PATCH_ACTUALITY"
export const PATCH_ACTUALITY_SUCCESS = "PATCH_ACTUALITY_SUCCESS"
export const ARCHIVED_ACTUALITY = "ARCHIVED_ACTUALITY"
export const ARCHIVED_ACTUALITY_SUCCESS = "ARCHIVED_ACTUALITY_SUCCESS"
export const DELETE_ACTUALITY = "DELETE_ACTUALITY"
export const DELETE_ACTUALITY_SUCCESS = "DELETE_ACTUALITY_SUCCESS"
//**************************** GOVERNANCE *******************************
// GET
export const GET_GOVERNANCE = "GET_GOVERNANCE"
export const GET_GOVERNANCE_SUCCESS = "GET_GOVERNANCE_SUCCESS"
export const GET_GOVERNANCE_BY_ID = "GET_GOVERNANCE_BY_ID"
export const GET_GOVERNANCE_BY_ID_SUCCESS = "GET_GOVERNANCE_BY_ID_SUCCESS"
export const POST_GOVERNANCE = "POST_GOVERNANCE"
export const POST_GOVERNANCE_SUCCESS = "POST_GOVERNANCE_SUCCESS"
export const PATCH_GOVERNANCE = "PATCH_GOVERNANCE"
export const PATCH_GOVERNANCE_SUCCESS = "PATCH_GOVERNANCE_SUCCESS"
export const DELETE_GOVERNANCE = "DELETE_GOVERNANCE"
export const DELETE_GOVERNANCE_SUCCESS = "DELETE_GOVERNANCE_SUCCESS"
//************************ DOCUMENTS_SOLLICITE ***************************
// GET
export const GET_DOCUMENT_SOLLICITE = "GET_DOCUMENT_SOLLICITE"
export const GET_DOCUMENT_SOLLICITE_SUCCESS = "GET_DOCUMENT_SOLLICITE_SUCCESS"
export const GET_DOCUMENTS_WAIT_VALIDATION = "GET_DOCUMENTS_WAIT_VALIDATION"
export const GET_DOCUMENTS_WAIT_VALIDATION_SUCCESS = "GET_DOCUMENTS_WAIT_VALIDATION_SUCCESS"
// GET DOCUMENTS BY CONTROL ID
export const GET_DOCUMENTS_BY_CONTROL_ID = "GET_DOCUMENTS_BY_CONTROL_ID"
export const GET_DOCUMENTS_BY_CONTROL_ID_SUCCESS = "GET_DOCUMENTS_BY_CONTROL_ID_SUCCESS"
// PATCH
export const PATCH_DOCUMENT_SOLLICITE = "PATCH_DOCUMENT_SOLLICITE"
// DELETE
export const DELETE_DOCUMENT_SOLLICITE = "DELETE_DOCUMENT_SOLLICITE"
// OTHERS
export const CONFIRM_DOCUMENTS_ADDED_BY_CLIENT = "CONFIRM_DOCUMENTS_ADDED_BY_CLIENT"
export const VALIDATE_DOCUMENT_SOLLICITE = "VALIDATE_DOCUMENT_SOLLICITE"
export const REJECT_DOCUMENT_SOLLICITE = "REJECT_DOCUMENT_SOLLICITE"
// DOCUMENTS ASSOCIATE RESPONSE CONTROL
export const POST_DOCUMENTS_ASSOCIATE_RESPONSE = "POST_DOCUMENTS_ASSOCIATE_RESPONSE"
export const POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK =
  "POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK"
export const GET_DOCUMENTS_ASSOCIATE_RESPONSE = "GET_DOCUMENTS_ASSOCIATE_RESPONSE"
export const GET_DOCUMENTS_ASSOCIATE_RESPONSE_SUCCESS = "GET_DOCUMENTS_ASSOCIATE_RESPONSE_SUCCESS"
export const DELETE_DOCUMENT_ASSOCIATE_BY_ID = "DELETE_DOCUMENT_ASSOCIATE_BY_ID"
export const POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK_V2 = "POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK_V2"
//************************* CONTROL_ARCHIVED ****************************
// GET
export const GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS = "GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS"
export const GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS_SUCCESS =
  "GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS_SUCCESS"
export const SET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS = "SET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS"
// LOADER
export const SET_LOADER_DATA = "SET_LOADER_DATA"
